import { ERROR, LOADING, OK } from "../constants";
import { Indexes } from "../types";
type SampleState = {
  data?: any;
  indexes?: Indexes;
};
export function getRequestCaseData<S extends SampleState>(state: S, itemId: number): any[] {
  let data = state.data;
  const indexes = state.indexes;
  if (indexes) data[indexes[itemId]] = { ...data[indexes[itemId]], status: LOADING, error: {} };
  const newData = [...data];
  return newData;
}

export function getSuccessCaseData<S extends SampleState>(state: S, itemId: number, actionPayload: any): any[] {
  let data = state.data;
  const indexes = state.indexes;
  if (indexes) data[indexes[itemId]] = { ...data[indexes[itemId]], status: OK, error: {}, ...actionPayload };
  const newData = [...data];
  return newData;
}

export function getFailureCaseData<S extends SampleState>(state: S, itemId: number, actionPayload: any): any[] {
  let data = state.data;
  const indexes = state.indexes;
  if (indexes) data[indexes[itemId]] = { ...data[indexes[itemId]], status: ERROR, error: actionPayload };
  const newData = [...data];
  return newData;
}
